// Firebase.js

import { initializeApp } from "firebase/app";

// Initialize Firebase
const config = {
    apiKey: "AIzaSyDmdO0y52xUYUZNSNT8HXD3aHB4H9Zna8E",
    authDomain: "ajit-furniture-house.firebaseapp.com",
    projectId: "ajit-furniture-house",
    storageBucket: "ajit-furniture-house.appspot.com",
    messagingSenderId: "482005071215",
    appId: "1:482005071215:web:2a2925b211336b5c64e49a",
    measurementId: "G-2P3NLV6EWE"
};

// setting a variable that initializes our application
const firebase = initializeApp(config);

// this exports the CONFIGURED version of firebase
export default firebase;